/**
 * @return {{click: string}}
 */
export const quiz = () => ({
  click: 'commencer_le_quiz',
});
